<template>
	<div class="recommend">
		<p class="title">特别推荐</p>
		<ul class="list">
			<li v-if="data.length==0" style="width: 100%;"><a style="color: #ccc;">暂无数据</a></li>
			<li v-for="(item,index) in data" :key="index" v-else>
				<router-link to="/detail">
					<div class="li_div">
						<div class="div_left">
							<img :src="item.title_pic" alt="">
						</div>
						<div class="div_right">
							<h2>{{item.title}}</h2>
							<p>{{item.brief}}</p>
						</div>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		props:{
			data:{
				required:true,
				type:Array
			}
		},
	}
	
</script>

<style scoped>
	.recommend {
		margin-bottom: 20px;
	}

	.title {
		border-bottom: 1px solid #eaeaea;
		border-radius: 5px 5px 0 0;
		background-color: #F7F7F7;
		font-weight: 400;
		font-size: 15px;
		line-height: 33px;
		text-indent: 20px;
	}

	.list {
		width: 100%;
		overflow: hidden;
	}

	.list li {
		width: 50%;
		float: left;
		margin-bottom: 1px;
	}

	.list li a {
		display: block;
		background-color: #FFFFFF;
		padding: 10px 20px;
		box-sizing: border-box;
	}

	.list li:nth-child(odd) a {
		margin-right: 1px;
	}

	.list li a:hover {
		background-color: #fafff8;
	}

	.list li a:hover .div_right h2 {
		color: #4eae30;
	}

	.li_div {
		overflow: hidden;
	}

	.div_left {
		float: left;
		width: 30%;
		height: 90px;
	}

	.div_left img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}

	.div_right {
		float: left;
		width: 70%;
		height: 90px;
		padding: 10px;
		box-sizing: border-box;
	}

	.div_right h2 {
		overflow: hidden;
		height: 25px;
		font-weight: 700;
		font-size: 14px;
	}

	.div_right p {
		color: #999;
		line-height: 20px;
		font-size: 12px;
	}
</style>
